import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { InputTextModule } from 'primeng/inputtext';
import { SidebarModule } from 'primeng/sidebar';
import { BadgeModule } from 'primeng/badge';
import { RadioButtonModule } from 'primeng/radiobutton';
import { InputSwitchModule } from 'primeng/inputswitch';
import { RippleModule } from 'primeng/ripple';
import { AppMenuComponent } from './app.menu.component';
import { AppMenuitemComponent } from './app.menuitem.component';
import { RouterModule } from '@angular/router';
import { AppTopBarComponent } from './app.topbar.component';
import { AppFooterComponent } from './app.footer.component';
import { AppConfigModule } from './config/config.module';
import { AppSidebarComponent } from './app.sidebar.component';
import { AppLayoutComponent } from './app.layout.component';

//=== INIZIO IMPORT PRIMENG
import { ChipModule } from 'primeng/chip';
import { ButtonModule } from 'primeng/button';
import { ContextMenuModule } from 'primeng/contextmenu';
import { SplitButtonModule } from 'primeng/splitbutton';
import { CascadeSelectModule } from 'primeng/cascadeselect';
import { TableModule } from 'primeng/table';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';
import { TooltipModule } from 'primeng/tooltip';
import { DropdownModule } from 'primeng/dropdown';
import { PasswordModule } from 'primeng/password';
import { CalendarModule } from 'primeng/calendar';
import { InputNumberModule } from 'primeng/inputnumber';
import { DialogModule } from 'primeng/dialog';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { FileUploadModule } from 'primeng/fileupload';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { StepsModule } from 'primeng/steps';
import { ChartModule } from 'primeng/chart';
import { KnobModule } from 'primeng/knob';
import { MenuModule } from 'primeng/menu';
import { TabViewModule } from 'primeng/tabview';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { TagModule } from 'primeng/tag';
import { MultiSelectModule } from 'primeng/multiselect';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { DividerModule } from 'primeng/divider';
import { AppLandingComponent } from './app.landing.component';
import { NotfoundComponent } from './components/error/notfound/notfound.component';
import { UnderConstructionComponent } from './components/error/under-construction/under_construction.component';
import { LottieModule } from 'ngx-lottie';
import {DialogService} from "primeng/dynamicdialog";
import { MessageService } from 'primeng/api';

@NgModule({
    providers: [
        DialogService,
        MessageService,
    ],
    declarations: [
        AppMenuitemComponent,
        AppTopBarComponent,
        AppFooterComponent,
        AppMenuComponent,
        AppSidebarComponent,
        AppLayoutComponent,
        AppLandingComponent,
        NotfoundComponent,
        UnderConstructionComponent,
    ],
    imports: [
        BrowserModule,
        FormsModule,
        LottieModule,

        HttpClientModule,
        BrowserAnimationsModule,
        InputTextModule,
        SidebarModule,
        BadgeModule,
        RadioButtonModule,
        InputSwitchModule,
        RippleModule,
        RouterModule,
        AppConfigModule,
        ButtonModule,
        DividerModule,
        ContextMenuModule,
        SplitButtonModule,
        CascadeSelectModule,
        TableModule,
        ConfirmDialogModule,
        ToastModule,
        TooltipModule,
        InputSwitchModule,
        InputTextModule,
        DropdownModule,
        PasswordModule,
        CalendarModule,
        InputNumberModule,
        DialogModule,
        InputTextareaModule,
        FileUploadModule,
        ToggleButtonModule,
        StepsModule,
        ChartModule,
        KnobModule,
        BadgeModule,
        ChipModule,
        MenuModule,
        TabViewModule,
        TieredMenuModule,
        TagModule,
        MultiSelectModule,
        AutoCompleteModule,
    ],
    exports: [AppLayoutComponent],
})
export class AppLayoutModule {}
